import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { path } from 'ramda'
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQuery } from '@apollo/client'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import richTextFragment from '@components/renderers/rich-text.fragment'
import { liveEventPostFragment } from './live-event.fragment'
import LiveEvent from './live-event'

const LIVE_EVENT_BY_SLUG = gql`
  query LiveEventBySlug($slug: String, $preview: Boolean) {
    liveEventCollection(limit: 1, preview: $preview, where: { slug: $slug }) {
      total
      items {
        headline
        metaDescription
        coverageStartTime
        coverageEndTime
        heroImage {
          contentType
          url
          description
          height
          title
          width
        }
        liveEventRichText {
          ${richTextFragment}
        }
        heroCaption
        heroSource
        sys {
          firstPublishedAt
          publishedAt
        }
      }
    }
  }
`

const LIVE_EVENT_POSTS_BY_SLUG = gql`
  query LiveEventBySlug($slug: String, $limit: Int) {
    liveEventPostCollection(limit: $limit, skip: 0, order: [sys_firstPublishedAt_DESC], where: {liveEvent: {slug: $slug}}) {
      ${liveEventPostFragment}
    }
  }
`

export default function LiveEventWithData(props) {
  const {
    slug,
  } = props

  const liveEventQuery = useQuery(LIVE_EVENT_BY_SLUG, {
    variables: { slug },
  })

  const liveEventPostsQuery = useQuery(LIVE_EVENT_POSTS_BY_SLUG, {
    variables: { slug, limit: 10 },
  })

  const error = liveEventQuery.error || liveEventPostsQuery.error
  const loading = liveEventQuery.loading || liveEventPostsQuery.loading

  if (error) return <Error error={error} />
  if (loading) return <LinearProgress color="secondary" />
  const response = {
    eventPage: path(['data', 'liveEventCollection', 'items', 0], liveEventQuery),
    liveUpdates: path(['data', 'liveEventPostCollection'], liveEventPostsQuery),
  }
  return (
    <LiveEvent {...props} {...response} />
  )
}

LiveEventWithData.propTypes = {
  slug: PropTypes.string,
}
